import '@fontsource-variable/inter';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { reloadOnReturnAfterUpdate } from './app/update-on-return.ts';
import { watchInstallPrompt } from './lib/install.ts';
import { initTheme } from './lib/theme.ts';
import './styles/base.css';

const root = document.getElementById('root');
if (root === null) throw new Error('Élément #root introuvable');

// Thème appliqué avant le premier rendu (pas de script en ligne : la CSP l'interdit).
initTheme();
reloadOnReturnAfterUpdate();
// À poser avant le premier rendu : le navigateur émet son offre d’installation très tôt.
watchInstallPrompt();

// Le contenu de repli SEO (index.html) est remplacé par l'application.
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
